import React from 'react';
import { FileManagerItemGrid } from './FileManagerItem';

const FileManagerGrid = ({
    folders,
    documents,
    selectedFolders,
    selectedDocuments,
    selectionMode,
    onSelect,
    onOpen,
    onContextMenu,
    onDragStart,
    onDragEnd,
    onDrop,
    isDragging
}) => {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2 marquee-area content-start">
            {/* Folders first */}
            {folders.map((folder) => (
                <FileManagerItemGrid
                    key={`folder-${folder.id}`}
                    item={folder}
                    type="folder"
                    isSelected={selectedFolders.has(folder.id)}
                    onSelect={onSelect}
                    onOpen={onOpen}
                    onContextMenu={onContextMenu}
                    onDragStart={onDragStart}
                    onDragEnd={onDragEnd}
                    onDrop={onDrop}
                    isDragging={isDragging}
                    selectedFolders={selectedFolders}
                    selectedDocuments={selectedDocuments}
                    selectionMode={selectionMode}
                />
            ))}

            {/* Then documents */}
            {documents.map((doc) => (
                <FileManagerItemGrid
                    key={`doc-${doc.id}`}
                    item={doc}
                    type="document"
                    isSelected={selectedDocuments.has(doc.id)}
                    onSelect={onSelect}
                    onOpen={onOpen}
                    onContextMenu={onContextMenu}
                    onDragStart={onDragStart}
                    onDragEnd={onDragEnd}
                    onDrop={onDrop}
                    isDragging={isDragging}
                    selectedFolders={selectedFolders}
                    selectedDocuments={selectedDocuments}
                    selectionMode={selectionMode}
                />
            ))}
        </div>
    );
};

export default FileManagerGrid;
